export default __webpack_public_path__ + "static/media/team-5.25c6fa73.png";